export const Action = {
  SET_GENRE: 'genre/set',
  FETCH_FILMS: 'films/fetch',
  FETCH_SIMILAR_FILMS: 'films/fetch-similar',
  FETCH_COMMENTS: 'films/fetch-comments',
  FETCH_FAVORITE: 'films/fetch-favorite',
  FETCH_FILM: 'film/fetch',
  FETCH_PROMO: 'film/fetch-promo',
  INCREASE_COUNTER: 'counter/increase',
  RESET_COUNTER: 'counter/reset',
  FETCH_USER_STATUS: 'user/fetch-status',
  LOGIN_USER: 'user/login',
  LOGOUT_USER: 'user/logout',
  POST_COMMENT: 'film/post-comment',
  POST_FAVORITE: 'film/post-favorite',
};
